import './CookieBanner.css';

function CookieBanner() {
  const acceptCookies = () => {
    localStorage.setItem('cookiesAccepted', 'true');
    document.getElementById('cookie-banner').style.display = 'none';
  };

  if (localStorage.getItem('cookiesAccepted')) return null;

  return (
    <div id="cookie-banner" className="cookie-banner">
      <p>
        We use cookies to improve performance.
        <a href="https://commission.europa.eu/cookies-policy_en"> Learn more</a>.
      </p>
      <button onClick={acceptCookies}>Accept</button>
    </div>
  );
}

export default CookieBanner;
